<template>
    <page-loading v-if="loading"></page-loading>
    <vx-page-layout v-else :layout="props.agentId ? 'sidebar' : 'create'">
        <template v-slot:title>
            <span v-if="!props.agentId" class="inline-flex items-center gap-3">
                <font-awesome-icon widthAuto :icon="faSparkle" class="text-base"></font-awesome-icon>
                <span>New Agent</span>
            </span>
            <span v-else data-test="ai-message-vetting-agent-header">{{ agent?.name }}</span>
        </template>

        <template v-if="!props.agentId" v-slot:description>
            <span class="block">Define the rules this Agent should enforce. Be explicit and specific.</span>
            <span class="block">Describe what the message should include, avoid, or match.</span>
        </template>

        <template v-if="props.agentId" v-slot:subtitle>
            <a
                :href="`/settings/teams/${teamId}#/ai-blast-vetting`"
                class="no-underline! text-sky-600! text-base font-normal"
            >
                <font-awesome-icon widthAuto class="mr-1" :icon="faArrowLeft"></font-awesome-icon>
                All Agents
            </a>
        </template>

        <template v-if="props.agentId" v-slot:sidebar>
            <page-sidebar
                appearance="nested"
                :links="sidebarLinks"
                data-test="ai-message-vetting-agent-sidebar"
            ></page-sidebar>
        </template>

        <slot></slot>
    </vx-page-layout>
</template>

<script setup lang="ts">
import { VxPageLayout } from '@voxie/frontend-components';
import PageLoading from '~/components/general/PageLoading.vue';
import PageSidebar from '~/components/general/PageSidebar.vue';
import { computed, onMounted, provide } from 'vue';
import { PAGE_HEADING_LEVEL } from '~/provides/pageHeadingLevel';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faArrowLeft, faSparkle } from '@fortawesome/pro-solid-svg-icons';
import { useAiMessageVettingAgentDetails } from '~/composables/useAiMessageVettingAgentDetails';

const props = defineProps<{
    agentId?: number;
}>();

const teamId = Spark.state.currentTeam.id;
provide(PAGE_HEADING_LEVEL, 'h2');

const { mount, agent, loading } = useAiMessageVettingAgentDetails();

const sidebarLinks = computed(() => [
    {
        href: `/settings/teams/${teamId}/ai-agents/message-vetting/${props.agentId}`,
        label: 'Details',
    },
    {
        href: `/settings/teams/${teamId}/ai-agents/message-vetting/${props.agentId}/usage`,
        label: 'Usage',
    },
]);

onMounted(() => {
    mount(props.agentId);
});
</script>
